import {useTranslation} from "react-i18next";

export function useGetBikeType() {
    const {t} = useTranslation();
    return {
        BIKE: {
            type: 0,
            bikeType: t('bikeType_muscular')
        },
        ELECTRIC_BIKE: {
            type: 1,
            bikeType: t('bikeType_electric')
        }
    }
}

export function useBikeType() {
    const {t} = useTranslation();

    return [
        {
            id: 0,
            name: t('bikeType_muscular')
        },
        {
            id: 1,
            name: t('bikeType_electric'),
        }
    ]
}

